module.exports = __webpack_public_path__ + "static/media/app-store-download.11a4c62f.png";